import React from "react"

import ReactDOM from "react-dom"

import {Provider} from "react-redux"

import {createStore} from "redux"
// 放到苍穹页面直接使用
import {reducer} from "../store/store"

import CqRobot from "../components/cqRobot/cqRobot"
;(function (KDApi) {
    class MyComponent {
        constructor(model) {
            this.model = model
        }

        init = (props) => {
            KDApi.loadFile("./css/main.css", this.model, () => {
                const model = this.model
                const {configItems} = props
                const showInContainer =
                    configItems?.length && configItems.find((item) => item.key === "showType")?.value === "1"
                const store = createStore(reducer, {
                    dialogList: [],
                    showFpIframe: false,
                    fpParam: {},
                    showInContainer: showInContainer,
                    newPortal: false,
                    fpInvokeData: {
                        eventData: JSON.stringify({
                            setParam: {
                                billId: "",
                                invoceId: "",
                            },
                            itemClick: "根据现有信息生成差旅报销单",
                        }),
                        eventType: "setParam|itemClick",
                    },
                })
                this.store = store

                store.dispatch({
                    type: "initModel",
                    payload: model,
                })
                model.invoke("newChatbotSession", undefined)

                this.store?.dispatch({
                    type: "initParam",
                    payload: {
                        ...props.data,
                    },
                })

                // this.store.dispatch({
                //     type: "addNewAnswer",
                //     payload: {
                //         "error": null,
                //         "errorCode": 0,
                //         "success": true,
                //         "data": {
                //             "id": "1a4c9ec7-ac1e-461b-be0a-e54532d3b249",
                //             "intent": "enquire_financial_indicators",
                //             "title": "北京蒙牛有限公司的数据如下：余额为 -0.18千元。",
                //             "exit": false,
                //             "show": true,
                //             "broadcast": true,
                //             "continueRecord": false,
                //             "attachments": null,
                //             "faqQuestionType": null,
                //             "faqQuestionGroupId": 0,
                //             "card": null,
                //             "cardList": null,
                //             "cardListJson": [
                //                 JSON.stringify({
                //                     "type": "AdaptiveCard",
                //                     "$schema": "http://adaptivecards.io/schemas/adaptive-card.json",
                //                     "version": "1.2",
                //                     "speak": "卡片2",
                //                     "body": [
                //                         {
                //                             "type": "ColumnSet",
                //                             "columns": [
                //                                 {
                //                                     "type": "Column",
                //                                     "width": "26px",
                //                                     "items": [
                //                                         {
                //                                             "type": "Image",
                //                                             "url": "https://adaptivecards.io/content/airplane.png",
                //                                             "size": "Small",
                //                                             "width": "23px",
                //                                             "height": "23px",
                //                                             "horizontalAlignment": "Left",
                //                                         },
                //                                     ],
                //                                     "verticalContentAlignment": "Center",
                //                                 },
                //                                 {
                //                                     "type": "Column",
                //                                     "width": "stretch",
                //                                     "horizontalAlignment": "Center",
                //                                     "verticalContentAlignment": "Center",
                //                                     "items": [
                //                                         {
                //                                             "type": "TextBlock",
                //                                             "text": "差旅报销单",
                //                                             "wrap": true,
                //                                             "horizontalAlignment": "Left",
                //                                             "fontType": "Default",
                //                                             "size": "Medium",
                //                                             "weight": "Default",
                //                                             "color": "Accent",
                //                                         },
                //                                     ],
                //                                 },
                //                                 {
                //                                     "type": "Column",
                //                                     "width": "auto",
                //                                     "horizontalAlignment": "Right",
                //                                     "height": "stretch",
                //                                     "verticalContentAlignment": "Bottom",
                //                                     "items": [
                //                                         {
                //                                             "type": "Container",
                //                                             "items": [
                //                                                 {
                //                                                     "type": "TextBlock",
                //                                                     "text": "单据详情(尚未配置)",
                //                                                     "wrap": true,
                //                                                     "color": "Good",
                //                                                 },
                //                                             ],
                //                                             "selectAction": {
                //                                                 "type": "Action.Submit",
                //                                             },
                //                                         },
                //                                     ],
                //                                     "selectAction": {
                //                                         "type": "Action.Submit",
                //                                     },
                //                                 },
                //                             ],
                //                         },
                //                         {
                //                             "type": "Container",
                //                             "separator": true,
                //                             "items": [
                //                                 {
                //                                     "type": "ColumnSet",
                //                                     "columns": [
                //                                         {
                //                                             "type": "Column",
                //                                             "width": "stretch",
                //                                             "items": [
                //                                                 {
                //                                                     "type": "TextBlock",
                //                                                     "text": "出发城市",
                //                                                     "wrap": true,
                //                                                 },
                //                                             ],
                //                                         },
                //                                         {
                //                                             "type": "Column",
                //                                             "width": "stretch",
                //                                             "items": [
                //                                                 {
                //                                                     "type": "TextBlock",
                //                                                     "wrap": true,
                //                                                     "text": "{{.API2.content.cardBody[0].from}}",
                //                                                     "horizontalAlignment": "Right",
                //                                                 },
                //                                             ],
                //                                         },
                //                                     ],
                //                                 },
                //                                 {
                //                                     "type": "ColumnSet",
                //                                     "columns": [
                //                                         {
                //                                             "type": "Column",
                //                                             "width": "stretch",
                //                                             "items": [
                //                                                 {
                //                                                     "type": "TextBlock",
                //                                                     "text": "目的城市",
                //                                                     "wrap": true,
                //                                                 },
                //                                             ],
                //                                         },
                //                                         {
                //                                             "type": "Column",
                //                                             "width": "stretch",
                //                                             "items": [
                //                                                 {
                //                                                     "type": "TextBlock",
                //                                                     "text": "{{.API2.content.cardBody[0].to}}",
                //                                                     "wrap": true,
                //                                                     "horizontalAlignment": "Right",
                //                                                 },
                //                                             ],
                //                                         },
                //                                     ],
                //                                 },
                //                                 {
                //                                     "type": "ColumnSet",
                //                                     "columns": [
                //                                         {
                //                                             "type": "Column",
                //                                             "width": "stretch",
                //                                             "items": [
                //                                                 {
                //                                                     "type": "TextBlock",
                //                                                     "text": "出发日期",
                //                                                     "wrap": true,
                //                                                 },
                //                                             ],
                //                                         },
                //                                         {
                //                                             "type": "Column",
                //                                             "width": "stretch",
                //                                             "items": [
                //                                                 {
                //                                                     "type": "TextBlock",
                //                                                     "text": "{{.API2.content.cardBody[0].startdate}}",
                //                                                     "wrap": true,
                //                                                     "horizontalAlignment": "Right",
                //                                                 },
                //                                             ],
                //                                         },
                //                                     ],
                //                                 },
                //                                 {
                //                                     "type": "ColumnSet",
                //                                     "columns": [
                //                                         {
                //                                             "type": "Column",
                //                                             "width": "stretch",
                //                                             "items": [
                //                                                 {
                //                                                     "type": "TextBlock",
                //                                                     "text": "返回日期",
                //                                                     "wrap": true,
                //                                                 },
                //                                             ],
                //                                         },
                //                                         {
                //                                             "type": "Column",
                //                                             "width": "stretch",
                //                                             "items": [
                //                                                 {
                //                                                     "type": "TextBlock",
                //                                                     "text": "{{.API2.content.cardBody[0].enddate}}",
                //                                                     "wrap": true,
                //                                                     "horizontalAlignment": "Right",
                //                                                 },
                //                                             ],
                //                                         },
                //                                     ],
                //                                 },
                //                                 {
                //                                     "type": "ColumnSet",
                //                                     "columns": [
                //                                         {
                //                                             "type": "Column",
                //                                             "width": "stretch",
                //                                             "items": [
                //                                                 {
                //                                                     "type": "TextBlock",
                //                                                     "text": "出差事由",
                //                                                     "wrap": true,
                //                                                 },
                //                                             ],
                //                                         },
                //                                         {
                //                                             "type": "Column",
                //                                             "width": "stretch",
                //                                             "items": [
                //                                                 {
                //                                                     "type": "TextBlock",
                //                                                     "wrap": true,
                //                                                     "text": "{{.API2.content.cardBody[0].description}}",
                //                                                     "horizontalAlignment": "Right",
                //                                                 },
                //                                             ],
                //                                         },
                //                                     ],
                //                                 },
                //                             ],
                //                         },
                //                         {
                //                             "type": "Container",
                //                             "items": [
                //                                 {
                //                                     "type": "TextBlock",
                //                                     "text": "以上为行程信息，确认后请关联发票。",
                //                                     "wrap": true,
                //                                     "color": "Attention",
                //                                 },
                //                                 {
                //                                     "type": "ActionSet",
                //                                     "actions": [
                //                                         {
                //                                             "type": "Action.Submit",
                //                                             "title": "关联发票",
                //                                             "data": {
                //                                                 "eventData": "我要关联发票",
                //                                                 "eventType": "itemClick",
                //                                                 "show": false,
                //                                             },
                //                                         },
                //                                     ],
                //                                 },
                //                             ],
                //                         },
                //                     ],
                //                 }),
                //             ],
                //             "autoJumpUrl": null,
                //             "feedbackButton": [
                //                 {
                //                     "logo": "https://ai.kingdee.com:9992/ai20test/static/Icon/voiceAssistant_btn_like_normal.png",
                //                     "eventType": "fbPos_normal",
                //                     "eventData": "enquire_financial_indicators",
                //                     "highLightLogo":
                //                         "https://ai.kingdee.com:9992/ai20test/static/Icon/voiceAssistant_btn_like_select.png",
                //                 },
                //                 {
                //                     "logo": "https://ai.kingdee.com:9992/ai20test/static/Icon/voiceAssistant_btn_tread_normal.png",
                //                     "eventType": "fbNeg_normal",
                //                     "eventData": "enquire_financial_indicators",
                //                     "highLightLogo":
                //                         "https://ai.kingdee.com:9992/ai20test/static/Icon/voiceAssistant_btn_tread_select.png",
                //                 },
                //             ],
                //             "keepAlive": true,
                //             "dataList": [
                //                 {
                //                     "id": "1a4c9ec7-ac1e-461b-be0a-e54532d3b249",
                //                     "intent": "enquire_financial_indicators",
                //                     "title": "北京蒙牛有限公司的数据如下：余额为 -0.18千元。",
                //                     "exit": false,
                //                     "show": true,
                //                     "broadcast": true,
                //                     "continueRecord": false,
                //                     "attachments": null,
                //                     "faqQuestionType": null,
                //                     "faqQuestionGroupId": 0,
                //                     "card": null,
                //                     "cardList": null,
                //                     "cardListJson": [
                //                         '{"$schema":"http://adaptivecards.io/schemas/adaptive-card.json","type":"AdaptiveCard","body":[{"type":"Container","items":[{"spacing":"Small","columns":[{"width":"18px","verticalContentAlignment":"Center","type":"Column","items":[{"width":"18px","type":"Image","url":"https://ai.kingdee.com:9992/ai20test/static/Icon/skill/pic4.png","height":"18px","rowId":0}]},{"horizontalAlignment":"Center","width":"auto","verticalContentAlignment":"Center","type":"Column","items":[{"horizontalAlignment":"Left","size":"Medium","weight":"Bolder","text":"财务指标查询","type":"TextBlock","rowId":1}]},{"horizontalAlignment":"Center","width":"auto","verticalContentAlignment":"Center","type":"Column","items":[{"horizontalAlignment":"Left","spacing":"Small","text":" ","type":"TextBlock","rowId":2}]}],"type":"ColumnSet"},{"minHeight":"44px","horizontalAlignment":"Left","spacing":"medium","columns":[{"horizontalAlignment":"Center","spacing":"None","width":"stretch","type":"Column","items":[{"horizontalAlignment":"Left","text":"余额","type":"TextBlock"},{"horizontalAlignment":"Left","spacing":"None","size":"Large","color":"Attention","text":"￥-0.18千元","type":"TextBlock"}]}],"type":"ColumnSet"}]}],"version":"1.0"}',
                //                     ],
                //                     "autoJumpUrl": null,
                //                     "feedbackButton": [
                //                         {
                //                             "logo":
                //                                 "https://ai.kingdee.com:9992/ai20test/static/Icon/voiceAssistant_btn_like_normal.png",
                //                             "eventType": "fbPos_normal",
                //                             "eventData": "enquire_financial_indicators",
                //                             "highLightLogo":
                //                                 "https://ai.kingdee.com:9992/ai20test/static/Icon/voiceAssistant_btn_like_select.png",
                //                         },
                //                         {
                //                             "logo":
                //                                 "https://ai.kingdee.com:9992/ai20test/static/Icon/voiceAssistant_btn_tread_normal.png",
                //                             "eventType": "fbNeg_normal",
                //                             "eventData": "enquire_financial_indicators",
                //                             "highLightLogo":
                //                                 "https://ai.kingdee.com:9992/ai20test/static/Icon/voiceAssistant_btn_tread_select.png",
                //                         },
                //                     ],
                //                     "keepAlive": true,
                //                     "dataList": null,
                //                 },
                //             ],
                //         },
                //         "trackId": "2acef0afb84d6",
                //     },
                // })

                const provider = (
                    <Provider store={store}>
                        <CqRobot />
                    </Provider>
                )
                ReactDOM.render(provider, model.dom)
            })
        }

        update = (props) => {
            this.store?.dispatch({
                type: "initParam",
                payload: {
                    ...props.data,
                },
            })
        }
    }

    // 注册自定义组件
    KDApi.register("xiao_k_frontpage", MyComponent)
})(window.KDApi)
